// extracted by mini-css-extract-plugin
export var actions = "_1i-0";
export var actionsContainer = "_1i-7";
export var border = "_1i-1";
export var childFullHeight = "_1i-e";
export var collapse = "_1i-2";
export var content = "_1i-9";
export var contentChild = "_1i-d";
export var fullscreen = "_1i-b";
export var hasLeftRadius = "_1i-q";
export var headerContainer = "_1i-3";
export var headerRow = "_1i-5";
export var hidePadding = "_1i-a";
export var navCollapsedGap = "_1i-r";
export var noScrollX = "_1i-s";
export var noScrollY = "_1i-t";
export var noTopPadding = "_1i-o";
export var optOutTopPadding = "_1i-c";
export var outletContent = "_1i-k";
export var outletContentInner = "_1i-l";
export var outletLeadingPanel = "_1i-h";
export var outletLeadingPanelAttention = "_1i-i";
export var outletResizeDivider = "_1i-j";
export var outletSplit = "_1i-f";
export var outletSplitResizing = "_1i-g";
export var pageMain = "_1i-p";
export var pageOuter = "_1i-m";
export var pagePadding = "_1i-8";
export var profile = "_1i-u";
export var profileContainer = "_1i-v";
export var profileImage = "_1i-w";
export var profileMain = "_1i-x";
export var profileSubtitle = "_1i-z";
export var profileTitle = "_1i-y";
export var showLeftPadding = "_1i-n";
export var tabsPortalSlot = "_1i-6";
export var tabsWrapper = "_1i-4";
export var title = "_1i-10";